import { ExecutiveDashboard } from "./ExecutiveDashboard";

/** Desktop home page: the weekly executive dashboard inside the standard layout. */
export const Dashboard = () => <ExecutiveDashboard />;
